import React, {useContext, useEffect, useState} from 'react';
import clsx from 'clsx';
import styles from './CookieRevoke.module.scss';
import {CookieConsentContext} from '../../../../utils/cookiesUtil';

const CookieRevoke = (elementClass = null) => {
  const {cookieConsent, setCookieConsent} = useContext(CookieConsentContext);
  const [isCookiesSet, setIsCookiesSet] = useState(Boolean(cookieConsent));
  const [domLoaded, setDomLoaded] = useState(false);

  function revoke_permission() {
    document.cookie.split(';').forEach((cookie) => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=${new Date(0).toUTCString()}`;
    });
    setIsCookiesSet(false);

    window.location.reload();
  }

  useEffect(() => {
    setDomLoaded(true);
  }, []);

  if (isCookiesSet && domLoaded) {
    return (
      <p className={clsx(styles.revoke_permission, elementClass?.elementClass)} onClick={revoke_permission}>
        <span> Отозвать соглашение на </span>
        <span> обработку персональных данных </span>
      </p>
    );
  }

  return <></>;
};

export default CookieRevoke;
